<template>
  <div>
    <div class="flex justify-between items-center my-4">
      <h5><i class="dot"></i> {{ $t(title) }}</h5>
      <div v-if="!isPrint && !readonly">
        <vs-button class="" color="secondary" type="border" @click="handleAddRow">{{ $t('항목추가') }}</vs-button>
        <vs-button class="ml-4" color="secondary" @click="handleRemoveRow">{{ $t('선택삭제') }}</vs-button>
      </div>
    </div>
    <div class="overflow-x-auto">
      <table :style="{ minWidth: isPrint ? '' : '1600px' }">
        <colgroup>
          <col v-if="!isPrint && !readonly" width="36" style="background: #f9f9f9" />
          <col width="160" />
          <col />
          <col width="90" />
          <col width="90" />
          <col width="90" />
          <col width="160" />
          <col width="260" />
        </colgroup>
        <thead>
        <tr>
          <th v-if="!isPrint && !readonly" rowspan="2" class="p-0"><vs-checkbox :value="0 < list.length && checkIds.length === list.length" @click.native="onClickAllCheck" class="checkbox" /></th>
          <th rowspan="2">{{ $t('세부작업명') }}</th>
          <th rowspan="2">{{ $t('검토의견') }}</th>
          <th colspan="3">{{ $t('검토의견 반영 위험도') }}</th>
          <th rowspan="2">{{ $t('검토자') }}</th>
          <th rowspan="2">{{ $t('비고') }}</th>
        </tr>
        <tr>
          <th>
            <div>
              <p>{{ $t('가능성') }}</p>
              <vx-tooltip title="가능성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
                <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px" @click="onClickToolTip1()" />
              </vx-tooltip>
            </div>
          </th>
          <th>
            <div>
              <p>{{ $t('중대성') }}</p>
              <vx-tooltip title="중대성이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
                <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px" @click="onClickToolTip2()" />
              </vx-tooltip>
            </div>
          </th>
          <th>
            <div>
              <p>{{ $t('위험도') }}</p>
              <vx-tooltip title="위험도이란?" :html="'자세한 정보를 보시려면<br>느낌표ⓘ 아이콘을 클릭하세요'" style="margin-left: 4px; display: flex; align-items: center; justify-content: center" position="top" delay=".1s">
                <feather-icon icon="AlertCircleIcon" style="cursor: pointer; width: 16px" @click="onClickToolTip3()" />
              </vx-tooltip>
            </div>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, item_i) in list" :key="item.id">
          <td v-if="!isPrint && !readonly" class="p-0"><vs-checkbox :vs-value="item.id" v-model="checkIds" class="checkbox" /></td>
          <td>
            <p v-if="isPrint" class="print-textarea no-block">{{ item.input1 }}</p>
            <ml-textarea v-else :readonly="readonly" rows="3" v-model="item.input1" class="w-full mb-0" />
          </td>
          <td>
            <p v-if="isPrint" class="print-textarea no-block">{{ item.input2 }}</p>
            <ml-textarea v-else :readonly="readonly" rows="3" v-model="item.input2" class="w-full mb-0" />
          </td>
          <td>
            <p v-if="isPrint" class="text-center">{{ item.input3 }}</p>
            <CustomOptionSelector v-else :readonly="readonly" :options="[1, 2, 3]" v-model="item.input3" @input="changeRisk(item_i)" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="text-center">{{ item.input4 }}</p>
            <CustomOptionSelector v-else :readonly="readonly" :options="[1, 2, 3]" v-model="item.input4" @input="changeRisk(item_i)" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="text-center" :style="{ color: riskColor(item.input5) }">{{ item.input5 }}</p>
            <ml-input v-else readonly v-model="item.input5" class="w-full text-center" :style="{ color: riskColor(item.input5) }" />
          </td>
          <td>
            <p v-if="isPrint">{{ item.input6 }}</p>
            <ml-input v-else :readonly="readonly" v-model="item.input6" class="w-full" />
          </td>
          <td>
            <p v-if="isPrint" class="print-textarea no-block">{{ item.input7 }}</p>
            <ml-textarea v-else :readonly="readonly" v-model="item.input7" rows="3" class="w-full mb-0" />
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <popup-risk-info-ep1_3x3 v-model="showInfoPopup1" />
    <popup-risk-info-ep2_3x3 v-model="showInfoPopup2" />
    <popup-risk-info-ep3_3x3 v-model="showInfoPopup3" />
  </div>
</template>

<script>
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import PopupRiskInfoEp1 from "@/views/project/popup/PopupRiskInfoEp1.vue";
import PopupRiskInfoEp2 from "@/views/project/popup/PopupRiskInfoEp2.vue";
import PopupRiskInfoEp3 from "@/views/project/popup/PopupRiskInfoEp3.vue";
import PopupRiskInfoEp1_3x3 from "@/views/project/popup/PopupRiskInfoEp1_3x3.vue";
import PopupRiskInfoEp2_3x3 from "@/views/project/popup/PopupRiskInfoEp2_3x3.vue";
import PopupRiskInfoEp3_3x3 from "@/views/project/popup/PopupRiskInfoEp3_3x3.vue";

export default {
  components: {
    PopupRiskInfoEp3_3x3,
    PopupRiskInfoEp2_3x3,
    PopupRiskInfoEp1_3x3,
    CustomOptionSelector,
    PopupRiskInfoEp3,
    PopupRiskInfoEp2,
    PopupRiskInfoEp1,
  },
  props: {
    title: { type: String, default: "" },
    value: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
    isPrint: { type: Boolean, default: false },
  },
  data() {
    return {
      checkIds: [],
      list: this.value,
      numberId: 0 < this.value.length ? this.value[this.value.length - 1].id : 0,

      showInfoPopup1: false,
      showInfoPopup2: false,
      showInfoPopup3: false,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.list = value;
        this.numberId = 0 < value.length ? value[value.length - 1].id : 0;
      },
    },
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleAddRow() {
      this.list.push({ id: ++this.numberId, input3: 1, input4: 1, input5: "낮음" });
    },
    handleRemoveRow() {
      this.list = this.list.filter((item) => !this.checkIds.includes(item.id));
      this.checkIds = [];
    },
    onClickAllCheck() {
      if (this.checkIds.length === this.list.length) this.checkIds = [];
      else this.checkIds = this.list.map((item) => item.id);
    },
    changeRisk(index) {
      const risk = this.list[index].input3 * this.list[index].input4;
      let riskKo = "";
      if (risk <= 2) riskKo = "낮음";
      else if (risk <= 4) riskKo = "보통";
      else riskKo = "높음";
      this.list[index].input5 = riskKo;
      this.$set(this.list[index], "input5", riskKo);
    },
    riskColor(risk) {
      switch (risk) {
        case "낮음":
          return "#28C76F";
        case "보통":
          return "#FF8510";
        default:
          return "#E42728";
      }
    },
    onClickToolTip1() {
      this.showInfoPopup1 = true;
    },
    onClickToolTip2() {
      this.showInfoPopup2 = true;
    },
    onClickToolTip3() {
      this.showInfoPopup3 = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  justify-content: center !important;
  &::v-deep {
    span {
      margin: 0px;
    }
  }
}
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  tr {
    th {
      font-weight: 700;
      font-size: 14px;
      line-height: 18px;
      align-items: center;
      text-align: center;

      background: #f9f9f9;
      border: 1px solid #cdcdcd;

      padding: 16px 6px;

      & > div {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    td {
      vertical-align: top;
      border: 1px solid #cdcdcd;
      padding: 6px;
      &:first-child {
        vertical-align: middle;
      }
    }
  }
}
</style>
